import {AdvancedLeadsContext} from "../../AdvancedSearch/context/context.ts"

export function useIsFilterDisabled() {
  const advancedFiltering = AdvancedLeadsContext.useOptionalContext()

  return advancedFiltering?.stage === "adding" || advancedFiltering?.stage === "searching"
}
